/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 LYRASOFT.
 * @license    __LICENSE__
 */

document.addEventListener('DOMContentLoaded', () => {
  AOS.init();

// 日程判斷
  const today = new Date();
  const todayTimestamp = today.getTime();
  let dateItems = document.querySelectorAll('.c-date-item');
  let isActiveAdded = false;
  // console.log(Date.parse('10 Mar 2024 00:00:00 GMT+8')); 時間修改用
  for (let i = 0; i < dateItems.length; i++) {
    const dataDateValue = dateItems[i].getAttribute('data-date');
    const dataDateEndValue = dateItems[i].getAttribute('data-date-end');

    if (!isActiveAdded && dataDateValue < todayTimestamp && todayTimestamp < dataDateEndValue) {
      dateItems[i].classList.add('active');
      isActiveAdded = true;
    }
  }

  // hp media swiper (desktop)
  for (let i = 1; i <= 4; i++) {
    let swiper = new Swiper(`.j-media-swiper-${i}`, {
      slidesPerGroup: 1,
      breakpoints: {
        768: {
          slidesPerGroup: 3,
          slidesPerView: 3,
          spaceBetween: 20,
        },
      }, freeMode: true,

      pagination: {
        el: `.j-media-pagination-${i}`,
      },

      navigation: {
        nextEl: `.j-media-next-${i}`,
        prevEl: `.j-media-prev-${i}`,
      },
    });
  }

  document.addEventListener('scroll', function () {
    let recruitWrapper = document.querySelector('.l-recruit');
    let dateItems = document.querySelectorAll('.c-date-item');
    let recruit = document.querySelector('.l-recruit__title');
    let recruitPosition = recruit.getBoundingClientRect();
    let windowHeight = window.innerHeight;

    if (recruitPosition.top < windowHeight) {
      recruitWrapper.classList.add('animated');
      dateItems.forEach(function (item) {
        item.classList.add('animated');
      });
    }
  });
});
